﻿import { useEffect, useState } from 'react';
import { EnteredLinks } from '../components/VideoLinks';
import { generateDummyArray } from '../utils';

export function useEnteredLinks(numberOfLinkInputs: number) {
    let [enteredLinks, setEnteredLinks] = useState<EnteredLinks>({});
    useEffect(() => {
        let updatedEnteredLinks = generateDummyArray(numberOfLinkInputs).reduce((acc, index) => {
            let previousValue = enteredLinks[`link-${index}`];
            acc[`link-${index}`] = previousValue ? previousValue : '';
            return acc;
        }, {});
        setEnteredLinks(updatedEnteredLinks);
    }, [numberOfLinkInputs]);

    return { enteredLinks, setEnteredLinks };
}
